import { render, staticRenderFns } from "./activityModalView.vue?vue&type=template&id=51bd81df&scoped=true"
import script from "./activityModalView.vue?vue&type=script&lang=js"
export * from "./activityModalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bd81df",
  null
  
)

export default component.exports